import { api } from '@/api/api-client.config.ts';
import { useMutation } from '@tanstack/react-query';
import { LeagueType } from '@/@types/api.types.ts';

const findLeagueByTitle = (title: string): Promise<{ league: LeagueType[] }> =>
  api.get(`/admin/league-search?title=${title}`);

export const useFindLeagueByTitleMutation = () => {
  return useMutation({
    mutationKey: ['findLeagueByTitle'],
    mutationFn: findLeagueByTitle,
  });
};
